import type { FaireProductEntity } from "../../entity_types/product";

export const p_2u3pxc888w: FaireProductEntity = {
  token: "p_2u3pxc888w",
  type: "product",
  name: "Hugger Socks  (Wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/82d4557157b5b6cdfe7d54e658a25bad085414dfecf74e7f3ec3e0c2318dba6c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2469d2f32c25344b0a1f1082ba2125d105b65aadebf0e89a9754d8cbeb76ac51.jpeg",
    "https://cdn.faire.com/fastly/f6d69bda7e0715240f2fb8b2021282c1f9f1ab4661dd0166c30b9942099856c0.jpeg",
    "https://cdn.faire.com/fastly/f92fbbe93c4c3401ed104609536aa90f683cbdf7a905ff2d396946958d7f53db.jpeg",
    "https://cdn.faire.com/fastly/639b52e0c07d3854fc968d7dab3d48d2431f91cb439fc199583ed84849dc5110.jpeg",
    "https://cdn.faire.com/fastly/91f5e2c6b592d140af2ab266d12b4d99eb8dce3f3e3a8ea8c16880810f06236f.jpeg",
    "https://cdn.faire.com/fastly/f6ca75a690c68b025189ff480f4a8e9de6ef4daf25048c88ebaf2952f419665e.jpeg",
    "https://cdn.faire.com/fastly/0afbdc6f53754d48f5625d62a3734e9df507be0a41d0d4227e2ee602737681b2.jpeg",
    "https://cdn.faire.com/fastly/c9573accaebc1dafd4f1491aa32edfb9b46ac16826f6005044cab7b6e048be78.jpeg",
    "https://cdn.faire.com/fastly/41a9c557533b5cf9ee8bfbe51c826b31ee5eb517dce111bf1c3fae5e50e9055f.jpeg",
    "https://cdn.faire.com/fastly/1b9e58a3e4f464095f82e2b40d570f0269b92a4d8d8858ad4f307c327fb228eb.jpeg",
    "https://cdn.faire.com/fastly/a3b48a065d3b0daa5e422981cd0aae328b7b2ab52df8ffb455b2c8ae3d4790f6.jpeg",
    "https://cdn.faire.com/fastly/a3bb1dd165f135f8edd0f5dd44e77f6cae397f1c924dc55f2e63a0573f6c2ed2.jpeg",
    "https://cdn.faire.com/fastly/3406f3ea62e392b4cd92741ea98271d0eab27f202ec3aeb7b38718155e91b5f4.jpeg",
    "https://cdn.faire.com/fastly/a7e7faaa271fb2434f5811567da7139c70b1794c96c92abbefa201d93fae6868.jpeg",
    "https://cdn.faire.com/fastly/6e2c54107dc1bf1cf17352f258d0d8153ca8bac4388316724026354214eb7d8c.jpeg",
    "https://cdn.faire.com/fastly/6c359d702e8d4363fcc3517ffee65ff6a1df3e7efdcec4ab7e6ee2da517318b9.jpeg",
    "https://cdn.faire.com/fastly/9089e9b7fb037d263c1764049dda7f09e4aaf31d9c79002d37c3ced69cff26b3.jpeg",
    "https://cdn.faire.com/fastly/92fa7d36472091984ff48695f93499f96cca5ea00df6ffad913439fe2f16cc99.jpeg",
    "https://cdn.faire.com/fastly/8075bc079df5945c131de590534bdb8a50a0723969e0b189adaa21f244e97f0b.jpeg",
    "https://cdn.faire.com/fastly/07473846446a47de5b73a385aba830651b6a19488010cab2d636459b4dae5b23.jpeg",
  ],
  priceDollars: 7,
  description:
    "𝐖𝐡𝐲 𝐖𝐞 𝐌𝐚𝐝𝐞 𝐓𝐡𝐢𝐬?\n\nThe introvert with a bubbly personality. Say hi to the Hugger Socks. Built on the same classic crew-length base as the Boyfriend Socks, with a clean, solid leg and a playful surprise underneath. A silicone motif on the sole adds a light grip, perfect for hugging flats, clogs, and slides.\n\nMade in South Korea\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n85 Cotton 13 Polyester 2 Spdx\n\n𝐒𝐢𝐳𝐢𝐧𝐠:\n\nOne size fits most (US women's size 6-10)\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Machine wash cold\n• Tumble dry low\n• Do not iron\n• Do not bleach\n\n*** Order in units of 6 (6,12,18,24 etc)\n\nMSRP: $16 USD",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:07.980Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
